<ngx-page-container>
  <nb-card class="filter">
    <nb-card-body>
      <div class="row">
        <div class="col-6">
          <div *ngIf="regions">
            <h5>Regions</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="regions"
              [(ngModel)]="filter.regions"></ss-multiselect-dropdown>

          </div>
          <div *ngIf="contacts">
            <h5>Region Sales Manager</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="contacts"
              [(ngModel)]="filter.rsms"></ss-multiselect-dropdown>
          </div>
          <div *ngIf="customers">
            <h5>Customers</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="customers"
              [(ngModel)]="filter.customers"></ss-multiselect-dropdown>
          </div>
          <div *ngIf="businessUnits">
            <h5>Business Units</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="businessUnits"
              [(ngModel)]="filter.bus"></ss-multiselect-dropdown>
          </div>
        </div>


        <div class="col-6">
          <!--<div *ngIf="regions">
            <h5>Business Unit</h5>
            <ss-multiselect-dropdown
              (ngModelChange)="loadReport()"
              [options]="businessUnits"
              [(ngModel)]="filter.bus"></ss-multiselect-dropdown>

          </div>-->
          <ngx-form-date [(value)]="filter.dateFrom" title="Date from" (valueChange)="loadReport()"></ngx-form-date>
          <ngx-form-date [(value)]="filter.dateTo" title="Date to" (valueChange)="loadReport()"></ngx-form-date>
          <!--<h5>Activity Types</h5>
          <ss-multiselect-dropdown
            (ngModelChange)="loadReport()"
            [options]="activityTypes"
            [(ngModel)]="filter.activitytypes"></ss-multiselect-dropdown>-->
        </div>
      </div>
    </nb-card-body>
  </nb-card>
  <a [routerLink]="[]" (click)="filter.withOverview = false; filter.plannedActivityReport = 0; downloadPdf()">Generate PDF</a>&nbsp;&nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="filter.withOverview = false; filter.plannedActivityReport = 0; downloadPdf(true)">Generate Short PDF</a>&nbsp;&nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="filter.withOverview = true; filter.plannedActivityReport = 0; downloadPdf()">Generate PDF with Project Overview</a>&nbsp;&nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="downloadPdfPresentation()">Generate Presentation</a> &nbsp;&nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="downloadPdfPresentationShort()">Generate Short Presentation</a>&nbsp;&nbsp;&nbsp;&nbsp;
  <a [routerLink]="[]" (click)="filter.withOverview = false; filter.plannedActivityReport = 1; downloadPdf(true)">Generate Planned Activity Report</a>&nbsp;&nbsp;&nbsp;&nbsp;

  <nb-card>
    <nb-tabset fullWidth *ngIf="reports" (changeTab)="tabsChange($event)">
      <nb-tab [tabTitle]="item.name" *ngFor="let item of reports | paginate: { itemsPerPage: 5, currentPage: p }"
              [active]="active[reports.indexOf(item)]">
        <div class="paging">
          <pagination-controls (pageChange)="changePage($event)" [autoHide]="true" ></pagination-controls>
        </div>
        <div class="company-info">
            <div class="row">
              <div class="col-4">Customer</div>
              <div class="col-8 info">{{item.name}}</div>
            </div>
            <div class="row">
              <div class="col-4">Country</div>
              <div class="col-8 info">{{getCountry(item)}}</div>
            </div>
            <div class="row">
              <div class="col-4">City</div>
              <div class="col-8 info">{{getCity(item)}}</div>
            </div>
            <div class="row">
              <div class="col-4">Region sales manager</div>
              <div class="col-8 info">{{$any(item.manager)?.title}}</div>
            </div>
        </div>

        <nb-accordion multi>
          <nb-accordion-item (collapsedChange)="loadActivities(item._id)">
            <nb-accordion-item-header>
              Activity list
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <nb-card>
                <nb-card-header>
                  Activities
                </nb-card-header>
                <nb-card-body>
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Type</th>
                      <th>Date</th>
                      <!--<th>User</th>-->
                      <!--<th>Location</th>-->
                      <th>Title</th>
                      <th>Summary</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let a of activities">
                        <td>{{ActivityType[a.type]}}</td>
                        <td>{{a.date | date:'dd. MM. yyyy' }}</td>
                        <!--<td>{{a.owner}}</td>-->
                        <!--<td>{{a.location}}</td>-->
                        <td>{{a.title}}</td>
                        <td>{{a.summary}}</td>
                      </tr>
                    </tbody>
                  </table>
                </nb-card-body>
              </nb-card>

            </nb-accordion-item-body>
          </nb-accordion-item>

          <nb-accordion-item (collapsedChange)="loadProjects(item._id)">
            <nb-accordion-item-header>
              Activity by project
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <div *ngFor="let p of projects">
                <nb-card *ngIf="p?.value.length > 0">
                  <nb-card-header>
                    <h4>{{p?.name}}</h4>
                  </nb-card-header>
                  <nb-card-body>
                    <table class="table table-hover">
                      <thead>
                        <th>Type</th>
                        <th>Date</th>
                        <!--<th>User</th>-->
                        <!--<th>Location</th>-->
                        <th>Topic</th>
                      </thead>
                      <tbody>
                        <tr *ngFor="let a of p.value" [class.light]="a.topic">
                          <td>{{ActivityType[a.type]}}</td>
                          <td>{{a.date | date:'dd. MM. yyyy' }}</td>
                          <!--<td>{{a.owner}}</td>-->
                          <!--<td>{{a.location}}</td>-->
                          <td>{{a.title}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </nb-card-body>
                </nb-card>
              </div>
            </nb-accordion-item-body>
          </nb-accordion-item>

          <nb-accordion-item [expanded]="true">
            <nb-accordion-item-header>
              Project overview
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <nb-card>
                <nb-card-header>Projects</nb-card-header>
                <nb-card-body>
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>BU</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th class="text-right">Probability</th>
                      <th class="text-right">Share</th>
                      <th class="text-right">Potential</th>
                      <th>Currency</th>
                      <th>Information</th>

                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let p of item.projects">
                        <td>{{p.businessUnit?.name}}</td>
                        <td>{{p.name}}</td>
                        <td>{{ProjectType[p.type]}}</td>
                        <td>{{ProjectStatus[p.status]}}</td>
                        <td class="text-right">{{(p.probability || 0) * 100}} %</td>
                        <td class="text-right">{{(p.share || 0) * 100}} %</td>
                        <td class="text-right">{{p.potential?.toLocaleString('en-US')}}</td>
                        <td>{{p.currency}}</td>
                        <td>{{p.summary}}</td>
                      </tr>
                    </tbody>
                  </table>
                </nb-card-body>
              </nb-card>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>
      </nb-tab>
    </nb-tabset>
    <div class="bottom-bar"></div>
  </nb-card>
</ngx-page-container>
